module.exports = __webpack_public_path__ + "static/media/album_cover_concept_sketch_2020.da28116e.webp";